// extracted by mini-css-extract-plugin
export var Hero = "Hero-module--Hero--36uFa";
export var Content = "Hero-module--Content--1uS4a";
export var Slideshow = "Hero-module--Slideshow--7aH3i";
export var imageAnimation = "Hero-module--imageAnimation--2Vkdv";
export var SlideshowText = "Hero-module--SlideshowText--CaWVO";